module.exports = __webpack_public_path__ + "img/131.74095fe6.png";